import $http from '../../axios';
import { Notification, MessageBox } from 'element-ui';

export async function loadDocumentAttachment({ commit, state }, document_id) {
    let formData = new FormData();

    formData.append("document_id", document_id);

    state.document_files_new.map(fn => {
        formData.append("filesUpload[]", fn);
    });

    state.document_files_delete.map(fn => {
        formData.append("filesDelete[]", JSON.stringify(fn));
    });

    await $http.post('/api/documento-contable-adjuntos', formData)
        .then((response) => {
            commit('setFiles', response.data.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function fetchFiles({ commit, state }, document_id) {
    if (!document_id) return;
    commit('setFiles', []);
    await $http
        .get(`/api/archivos-documento/${document_id}`)
        .then(response => {
            commit('setFiles', response.data)
        })
        .catch(error => {
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function deleteFile({ commit, state }, file) {
    await $http.delete(`/api/archivos-documento/${file.id}`)
        .then(response => {
            commit('setFiles', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchFilesCashRegisterUpdates({ commit, state }, cash_register_updates_id) {
    if (!cash_register_updates_id) return;
    commit('setFiles', []);
    await $http
        .get(`/api/caja-adjuntos/${cash_register_updates_id}`)
        .then(response => {
            commit('setFiles', response.data)
        })
        .catch(error => {
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function loadCashRegisterUpdatesAttachment({ commit, state }, cash_register_updates_id) {
    let formData = new FormData();

    formData.append("cash_register_updates_id", cash_register_updates_id);

    state.document_files_new.map(fn => {
        formData.append("filesUpload[]", fn);
    });

    await $http.post('/api/caja-adjuntos', formData)
        .then((response) => {
            commit('setFiles', response.data.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function deleteCashRegisterUpdatesFile({ commit, state }, file) {
    await $http.delete(`/api/caja-adjuntos/${file.id}`)
        .then(response => {
            commit('setFiles', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


// WEBPACK FOOTER //
// ./src/modules/modal-attachments/actions.js